
import { Component } from 'nuxt-property-decorator'
import CommonAcf from '../common/CommonAcf.vue'

@Component({
  name: 'CareersJobList',
})
export default class CareersJobList extends CommonAcf {}
